<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "WebPage",
  components: {LoadingPage},

  setup(){

    let page = ref(useRoute().params.type)
    let loading = ref(false)

    let weblog = ref([])
    let video = ref([])

    function advertise() {

      loading.value = true
      FreeWorld.Heisenberg({action:'advertise'} , 'info').then((res)=>{

        loading.value = false
        res.data.forEach((item)=>{
          if (item.type === 'weblog'){
            weblog.value.push(item)
          }else if(item.type === 'video' && item.apps === 'shop'){
            video.value.push(item)
          }
        })

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , advertise)
      })

    }
    advertise()

    return{

      page,
      weblog,
      video,
      loading,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">{{ page }}</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body mt-3">

      <div v-if="page === 'وبلاگ'" class="parent">

        <a :href="item.link" v-for="item in weblog" :key="item.id" class="animate__animated animate__fadeIn text-decoration-none item d-flex flex-column mx-1 mb-3">
          <span class="animated-background h-100 rounded-4 mb-3">
          <img class="w-100 img_item rounded-4" :src="item.pic" alt="">
          </span>

          <p class="bg-white rounded-4 font-6 p-2 text-center">{{ item.title }}</p>
        </a>

      </div>

      <div v-else class="parent">

        <a :href="item.link" v-for="item in video" :key="item.id" class="animate__animated animate__fadeIn text-decoration-none item d-flex flex-column mx-1 mb-3">
          <span class="animated-background rounded-4 mb-3">
          <img class="w-100 img_item h-100 rounded-4" :src="item.pic" alt="">
          </span>

          <p class="bg-white rounded-4 font-6 p-2 text-center">{{ item.title }}</p>
        </a>

      </div>

    </div>


  </div>

</template>


<style scoped>

.parent {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
@media (min-width:900px) {
  .item {
    flex-basis: 23% !important;
  }
  .img_item{
    height: 12rem !important;
  }
}
@media (min-width:600px) and (max-width: 899px) {
  .item {
    flex-basis: 30% !important;
  }
  .img_item{
    height: 10rem !important;
  }
}
.item {
  flex-grow: 0;
  flex-basis: 45%;
}
.img_item{
  height: 10rem;
}

</style>